import * as React from "react"

import { RETAILER_PRODUCTS_ROUTES, USER_ROLE } from "@constants"
import AppLayout from "Layout"
import RetailerProductsPage from "./index"


export const RetailerProductsRoutes = {
    path: RETAILER_PRODUCTS_ROUTES.PATH,
    title: RETAILER_PRODUCTS_ROUTES.TITLE,
    icon: 'store',
    iconWeight: 'light',
    element: <AppLayout />,
    description: RETAILER_PRODUCTS_ROUTES.SUBTITLE,
    access: USER_ROLE.ADMIN,
    children: [{
        element: <RetailerProductsPage />,
        index: true
    }]
}
